<template lang='pug'>
//- 建立新提問
div(:class='$style[`cc-popbox-control-question`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(v-if='feature === `create`' :class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 建
        span.font-normal-theme 立
        span.no-wrap 新討論
      span.font-bold(v-if='feature === `update`' :class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 編
        span.font-normal-theme 輯
        span.no-wrap 討論

    //- figure(:class='$style[`cc-content-banner-graphic`]')

    div(:class='$style[`cc-content-wrap`]')

      //- 標題
      div(:class='$style[`cc-content-wrap-input`]')
        div(:class='$style[`cc-content-input-left`]')
          span(:class='$style[`cc-content-input-left-title`]')!= '標題'

        div(:class='$style[`cc-content-input-right`]')
          Inputer(
            title='問題標題'
            v-model='qaConfig.titleValue'
            :key='`${nextTick}-title`'
            :class='$style[`cc-input-inputer`]'
            :placeholder='`填寫標題`'
            :defaultValue='qaConfig.titleValue'
            :emojiButton='true'
            :errorValue='checkEmptyStatus.titleError'
            @clearErrorMsg="(value) => {this.checkEmptyStatus.titleError = value[0]; this.showErrorMsg = false;}")

      //- 癌症
      div(:class='$style[`cc-content-wrap-input`]')
        div(:class='$style[`cc-content-input-left`]')
          span(:class='$style[`cc-content-input-left-title`]')!= '癌症'

        div(:class='$style[`cc-content-input-right`]')
          Select(
            title='癌症標籤'
            v-model='qaConfig.tagValue'
            :class='[$style[`cc-input-selector`], $style[`cc-input-type`]]'
            :key='`${nextTick}-select-tag`'
            :placeholder='`選擇癌症`'
            :defaultValue='qaConfig.tagValue'
            :optionList='CANCER_TYPE'
            :errorValue='checkEmptyStatus.tagError'
            @sendSelectValue='setTagSelectValue'
            @clearErrorMsg="(value) => {this.checkEmptyStatus.tagError = value}")

          Inputer(
            v-if='otherTagShow'
            v-model='qaConfig.tagValue'
            title='填寫分類名稱'
            style='margin-left: 8px;'
            :class='[$style[`cc-input-selector`], $style[`cc-input-type`], $style[otherTagShow ? `cc-half-width` : ``]]'
            :resetButton='false'
            :key='`${nextTick}-select-tag2`'
            :placeholder='`分類名稱`'
            :defaultValue='qaConfig.tagValue'
            :errorValue='checkEmptyStatus.tagError'
            @clearErrorMsg="(value) => {this.checkEmptyStatus.tagError = value[0];}")

      //- 分類
      div(:class='$style[`cc-content-wrap-input`]')
        div(:class='$style[`cc-content-input-left`]')
          span(:class='$style[`cc-content-input-left-title`]')!= '分類'

        div(:class='$style[`cc-content-input-right`]')
          Select(
            title='問題分類'
            v-model='qaConfig.typeValue'
            :class='[$style[`cc-input-selector`], $style[`cc-input-type`], $style[otherTypeShow ? `cc-half-width` : ``]]'
            :key='`${nextTick}-select-type`'
            :placeholder='`選擇分類`'
            :defaultValue='qaConfig.typeValue'
            :optionList='typeList'
            :errorValue='checkEmptyStatus.typeError'
            @sendSelectValue='setTypeSelectValue'
            @clearErrorMsg="(value) => {this.checkEmptyStatus.typeError = value}")

      //- 說明
      div(:class='$style[`cc-content-wrap-input`]')
        div(:class='$style[`cc-content-input-left`]')
          span(:class='$style[`cc-content-input-left-title`]')!= '說明'

        div(:class='[$style[`cc-content-input-right`], $style[`cc-content-input-flex-column`]]')
          //- :key='`${nextTick}-textarea`'
          TextAreaer(
            v-model='qaConfig.infoValue'
            title='問題內容說明'
            :autoSize='true'
            :key='`${nextTick}-textarea`'
            :class='$style[`cc-input-textarea`]'
            :errorValue='checkEmptyStatus.infoError'
            :defaultValue='qaConfig.infoValue'
            :emojiButton='true'
            :resetButton='false'
            :placeholder='`內容說明`'
            @clearErrorMsg="(value) => {this.checkEmptyStatus.infoError = value[0];}")

          CheckBox(
            v-model='qaConfig.readRuleValue'
            title='我會遵守發文規範'
            :errorValue='checkEmptyStatus.readRuleError'
            :labelText='`我會遵守<a href="${NODE_DOMAIN}/term" target="_blank" rel="noreferrer" title="發文規範">發文規範</a>`'
            @sendCheckStatus='setRuleCheckBoxStatus'
            @clearErrorMsg="(value) => {this.checkEmptyStatus.readRuleError = value}")

      div(
        v-if='feature === `create`'
        title='完成送出'
        :class='$style[`cc-content-bless-send`]'
        @click='handleCheckProgressBeforeSend')
        IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
        span {{ showLoading ? `` : `完成送出`}}

      div(
        v-else-if='feature === `update`'
        title='更新'
        :class='$style[`cc-content-bless-send`]'
        @click='handleCheckProgressBeforeSend')
        IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
        span {{ showLoading ? `` : `更新`}}


</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
// import qs from 'qs';

import IconLoading from '../../icon/Loading';
import IconEmoji from '../../icon/Emoji';
import Inputer from '../common/Input';
import Select from '../common/Select';
import TextAreaer from '../common/TextArea';
import CheckBox from '../common/Checkbox';
// import _ from 'lodash-core';

import {
  postCreateQuestion,
  getCurrentDate,
  getQaLoadStatus,
  putQaStatus,
} from '../../../js/restapi';

export default {
  components: {
    IconLoading,
    IconEmoji,
    Inputer,
    Select,
    TextAreaer,
    CheckBox,
  },

  mixins: [clickaway],

  props: {
    qid: {
      type: String,
      default: '',
    },

    feature: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showLoading: false,
      showTitleEmoji: false,
      showInfoEmoji: false,
      otherTagShow: false,
      otherTypeShow: false,

      qaConfig: {
        titleValue: '',
        tagValue: '',
        typeValue: '',
        infoValue: '',
        readRuleValue: false,
      },

      checkEmptyStatus: {
        titleError: false,
        titleErrorLog: '',

        tagError: false,
        tagErrorLog: '',

        typeError: false,
        typeErrorLog: '',

        infoError: false,
        infoErrorLog: '',

        readRuleError: false,
      },

      typeList: [
        '心情', '閒聊', '轉贈', '情報', '求助', '治療', '藥物',
      ],
      verifyAllPass: true,
      showErrorMsg: false,

      nextTick: 0,
    };
  },

  created() {
    // this.showErrorMsg = this.$options.data().showErrorMsg;
    if (this.feature === 'update') {
      this.initQaStatusOnUpdate();
    }
  },

  methods: {
    handleClosePopBox() {
      this.changePopQuestionStatus({
        active: false,
        userId: '',
      });
    },

    handleShowTitleEmojiList() {
      // this.showErrorMsg = this.$options.data().showErrorMsg;
      // this.verify.lengthError = this.$options.data().verify.lengthError;
      this.showTitleEmoji = !this.showTitleEmoji;
    },

    handleShowInfoEmojiList() {
      // this.showErrorMsg = this.$options.data().showErrorMsg;
      // this.verify.lengthError = this.$options.data().verify.lengthError;
      this.showInfoEmoji = !this.showInfoEmoji;
    },

    handleTitleEmojiOnBlur() {
      this.showTitleEmoji = false;
    },

    handleInfoEmojiOnBlur() {
      this.showInfoEmoji = false;
    },

    handleAppendTitleEmojiOnClick(emoji) {
      this.nextTick += 1;
      this.qaConfig.titleValue = this.qaConfig.titleValue + emoji;
    },

    handleAppendInfoEmojiOnClick(emoji) {
      this.nextTick += 1;
      this.qaConfig.infoValue = this.qaConfig.infoValue + emoji;
    },

    setTagSelectValue(value) {
      if (value === '填寫其他') {
        this.otherTagShow = true;
        this.qaConfig.tagValue = '';
      } else {
        this.otherTagShow = false;
        this.qaConfig.tagValue = value;
      }
    },

    setTypeSelectValue(value) {
      // this.resumeConfig.typeValue = value;
      if (value === '填寫其他') {
        this.otherTypeShow = true;
        this.qaConfig.typeValue = '';
      } else {
        this.otherTypeShow = false;
        this.qaConfig.typeValue = value;
      }
    },

    setRuleCheckBoxStatus(value) {
      // eslint-disable-next-line no-unused-expressions
      value === 'checked' ? this.qaConfig.readRuleValue = true : this.qaConfig.readRuleValue = false;
    },

    initQaStatusOnUpdate() {
      getQaLoadStatus(`/?qid=${this.qid}`)
        .then((res) => {
          const quesRes = res.data.results[0];
          const splitValue = quesRes.tag.split('、');
          // console.log('quesRes', quesRes);

          this.qaConfig = {
            titleValue: quesRes.title,
            tagValue: splitValue[1],
            typeValue: splitValue[0],
            infoValue: quesRes.describe,
          };
          this.nextTick += 1;
        })
        .catch((err) => {
          console.log('Axios getQaLoadStatus Error');
        });
    },

    handleFormCheckToPass() {
      // this.verifyAllPass = this.$options.data().verifyAllPass;
      this.verifyAllPass = true;

      // 驗證密碼欄位為空
      if (!this.qaConfig.titleValue) {
        this.checkEmptyStatus.titleError = true;
        this.checkEmptyStatus.titleErrorLog = '請輸入問題標題';
        this.verifyAllPass = false;
      }
      if (!this.qaConfig.tagValue) {
        this.checkEmptyStatus.tagError = true;
        this.checkEmptyStatus.tagErrorLog = '請選擇癌症';
        this.verifyAllPass = false;
      }
      if (!this.qaConfig.typeValue) {
        this.checkEmptyStatus.typeError = true;
        this.checkEmptyStatus.typeErrorLog = '請選擇分類';
        this.verifyAllPass = false;
      }
      if (!this.qaConfig.infoValue) {
        this.checkEmptyStatus.infoError = true;
        this.checkEmptyStatus.infoErrorLog = '請輸入問題說明';
        this.verifyAllPass = false;
      }
      if (!this.qaConfig.readRuleValue) {
        this.checkEmptyStatus.readRuleError = true;
        this.verifyAllPass = false;
      }
    },

    handleConnectDjangoWithApi() {
      if (!this.verifyAllPass) {
        return;
      }

      this.showLoading = true;
      if (this.feature === 'create') {
        this.axiosCreateNewQuestion();
      } else {
        this.axiosUpdateQuestion();
      }
    },

    axiosCreateNewQuestion() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      getCurrentDate('')
        .then((response) => {
          console.log('getCurrentDate', response);

          const POST_DATA = {
            auth_id: `${this.loginDjangoId}`,
            title: `【${this.qaConfig.typeValue}】${this.qaConfig.titleValue}`,
            tag: `${this.qaConfig.typeValue}、${this.qaConfig.tagValue}`,
            describe: `${this.qaConfig.infoValue}`,
            date: `${response.data}`,
          };

          postCreateQuestion('', POST_DATA, {
            headers: {
              'content-Type': 'application/json',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          })
            .then((res) => {
              console.log('新增提問 成功!', res);
              this.showLoading = false;
              this.handleUserAddHp(this.loginDjangoId, '+100');
              // this.handleUserAddScore(this.loginDjangoId, 'both', { hp: '+100', point: '+1' });
              this.changePopBoxStatus({
                active: true,
                include: 'createConfirm',
              });

              this.handleClosePopBox();

              this.$router.push({
                name: 'qa-detail',
                params: {
                  quesId: `${res.data.id}`,
                },
              }).catch(() => true);

              setTimeout(() => {
                this.changePopBoxStatus({
                  active: false,
                  include: '',
                });
              }, this.POP_DURATION);
            })
            .catch((error) => {
              this.showLoading = false;
              console.error('新增提問 失敗！', error.message);
            });
        })
        .catch((error) => {
          console.error('取得系統時間 失敗！', error.message);
        });
    },

    axiosUpdateQuestion() {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;
      const UPDATE_DATA = {
        title: `${this.qaConfig.titleValue}`,
        tag: `${this.qaConfig.typeValue}、${this.qaConfig.tagValue}`,
        describe: `${this.qaConfig.infoValue}`,
        // date: `${response.data}`,
      };

      putQaStatus(`?pk=${this.qid}`, UPDATE_DATA, {
        headers: {
          'content-Type': 'application/json',
          // Authorization: `Bearer ${jwtAccess}`,
        },
      })
        .then((res) => {
          console.log('新增提問 成功!', res);
          this.showLoading = false;
          this.changePopBoxStatus({
            active: true,
            include: 'updateConfirm',
          });

          this.handleClosePopBox();

          setTimeout(() => {
            this.changePopBoxStatus({
              active: false,
              include: '',
            });

            this.$router.go(this.$router.currentRoute);
            // this.$router.push({
            //   name: 'qa-detail',
            //   params: {
            //     quesId: `${this.qid}`,
            //   },
            // }).catch(() => true);
          }, this.POP_DURATION);
        })
        .catch((error) => {
          this.showLoading = false;
          console.error('新增提問 失敗！', error.message);
        });
    },

    async handleCheckProgressBeforeSend() {
      await this.handleFormCheckToPass();
      await this.handleConnectDjangoWithApi();
    },

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopBlessStatus: 'global/POPBLESS_STATUS',
      changePopQuestionStatus: 'global/POPQUESTION_STATUS',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      authJwtToken: 'user/exportUserJwtToken',
      loginDjangoId: 'user/exportUserDjangoId',
      // loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      // popBlessStatus: 'global/exportPopBlessStatus',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  // watch: {
  //   blessValue() {
  //     this.blessValueLength = _.toArray(this.blessValue).length;
  //   },
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popControlQuestion.scss';
</style>
